import React from 'react';
import { LayoutRoute } from '../../layout/routes';
import withLoading from '../../helpers/withLoading';

const About = withLoading(() => import('./'));

const route = <LayoutRoute path="/about-us" component={About} />;

export default route;
